<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form class="fn-clear" :inline="true">
          <el-form-item class="fn-left">
            <el-input v-model="listQuery.name" placeholder="请输入物品名称" />
          </el-form-item>
          <el-form-item class="fn-left">
            <el-select v-model="listQuery.type" placeholder="请选择类型">
              <el-option v-for="(item) in goodsTypeLists" :key="item.value+item.label" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item class="fn-left">
            <el-select v-model="listQuery.shipments_type" placeholder="请选择发货类型">
              <el-option v-for="(item) in shipmentsTypeLists" :key="item.value+item.label" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item class="fn-left">
            <el-select v-model="listQuery.purchase_type" placeholder="请选择采购合约">
              <el-option v-for="(item) in purchaseTypeLists" :key="item.value+item.label" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item class="fn-left">
            <el-select v-model="listQuery.in_sale" placeholder="请选择是否上架">
              <el-option label="上架" value="1" />
              <el-option label="下架" value="0" />
            </el-select>
          </el-form-item>
          <el-form-item class="fn-left">
            <el-checkbox v-model="listQuery.stock_alert" true-label="1" false-label="">是否显示库存不足</el-checkbox>
          </el-form-item>

          <!-- <el-form-item label="" class="fn-left">
            <el-checkbox v-model="listQuery.tll_status" true-label="20062018214508001072" false-label="">只看已无效的例子</el-checkbox>
          </el-form-item> -->
          <el-form-item label="" class="fn-left">
            <el-button type="success" @click="fnUpdateTable()">搜索</el-button>
          </el-form-item>
          <el-form-item label="" class="fn-right">
            <el-button type="primary" @click="fnCreate()">新增物品</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tuolele-main-box">
      <wq-table ref="puchselisttable" show-page sub-key="list" :other-query="listQuery" :url-func="$http.getGoodsList" @data-from-server="fnGetGoodsList">
        <el-table-column label="编号" prop="id" align="center" />
        <el-table-column label="图片" align="center">
          <template slot-scope="{row}">
            <el-image :src="row.photo" :preview-src-list="[row.photo]" />
          </template>
        </el-table-column>
        <el-table-column label="名称" prop="name" align="center" />
        <el-table-column label="分类" prop="type_name" align="center" />
        <el-table-column label="发货类型" prop="shipments_type_name" align="center" />
        <el-table-column label="合约类型" prop="purchase_type_name" align="center" />
        <el-table-column label="单价(元)" prop="money" align="center">
          <template slot-scope="{row}">
            <span>{{ row.money/100 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="库存预警值" prop="stock_alert" align="center" />
        <el-table-column label="当前库存" prop="stock" align="center" />
        <el-table-column label="所属仓库" prop="warehouse_name" align="center" />
        <el-table-column label="申请上限" prop="month_max_num" align="center">
          <template slot-scope="{row}">
            <span>{{ row.month_max_num == 0 ? '无限' : row.month_max_num }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="260">
          <template slot-scope="{row}">
            <el-button size="mini" type="text" @click="fnCreate(row)">编辑</el-button>
            <el-button v-if="row.in_sale == 1" style="color:#F56C6C!important" size="mini" type="text" @click="fnDownOrUp(row,'off')">下架</el-button>
            <el-button v-if="row.in_sale == 0" size="mini" type="text" @click="fnDownOrUp(row,'on')">上架</el-button>
            <el-button size="mini" type="text" @click="fnUpdateStock(row)">库存配置</el-button>
            <el-dropdown>
              <span class="el-dropdown-link">
                <el-button size="mini" type="text">更多</el-button><i class="el-icon-arrow-down " />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="fnDownOrUp(row,'delete')">删除</el-dropdown-item>
                <el-dropdown-item @click.native="fnStockLists(row)">库存记录</el-dropdown-item>
                <el-dropdown-item @click.native="fnConsume(row)">物品消耗</el-dropdown-item>

              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </wq-table>

    </div>
    <el-dialog
      title="库存记录"
      :visible.sync="dialogVisible1"
      width="80%"
    >
      <wq-table :key="`stockhistorylist${historytablekey}`" ref="stockhistorylist" :other-query="listQuery" :url-func="$http.getStockHistoryList">
        <el-table-column label="操作时间" prop="create_time" align="center" />
        <el-table-column label="操作人" prop="editor_name" align="center" />
        <el-table-column label="变更前库存" prop="original_num" align="center" />
        <el-table-column label="变更库存" prop="change_num" align="center" />
        <el-table-column label="备注" prop="comment" align="center">
          <template slot-scope="{row}">
            <div v-html="row.comment" />
          </template>
        </el-table-column>
      </wq-table>
    </el-dialog>
    <el-dialog
      title="库存增减"
      :visible.sync="dialogVisible2"
      width="80%"
    >
      <form-box key="changestockform" label-width="120px" :rules="rules" :forms="changeForms" :post-form="changePostForm" @submit="fnSubmitStockChange" />
    </el-dialog>
    <el-dialog
      title="物品消耗"
      :visible.sync="dialogVisible3"
      width="80%"
    >
      <form-box key="consumeform" label-width="120px" :rules="rules" :forms="consumeForms" :post-form="consumePostForm" @submit="fnSubmitConsume" />
    </el-dialog>
    <el-dialog
      title="物品操作"
      top="10vh!important"
      :visible.sync="dialogVisible4"
      width="80%"
    >
      <form-box ref="goodsforms" :key="`goodsforms${goodsFormKey}`" label-width="150px" :forms="goodForms" :post-form="goodPostForm" @submit="fnCreateSumbit">
        <template v-slot:type="{currentForm,item}">
          <wq-select :placeholder="`请选择${item.label}`" :columns="goodsTypeLists" :name="item.bindValue" :selected.sync="currentForm[item.bindValue]" value-name="value" text-name="label" />
        </template>
        <template v-slot:shipments_type="{currentForm,item}">
          <wq-select :placeholder="`请选择${item.label}`" :columns="shipmentsTypeLists" :name="item.bindValue" :selected.sync="currentForm[item.bindValue]" value-name="value" text-name="label" />
        </template>
        <template v-slot:purchase_type="{currentForm,item}">
          <wq-select :placeholder="`请选择${item.label}`" :columns="purchaseTypeLists" :name="item.bindValue" :selected.sync="currentForm[item.bindValue]" value-name="value" text-name="label" />
        </template>
        <template v-slot:warehouse_id="{currentForm,item}">
          <wq-select :placeholder="`请选择${item.label}`" :columns="warehouseList" :name="item.bindValue" :selected.sync="currentForm[item.bindValue]" value-name="id" text-name="name" />
        </template>
      </form-box>
    </el-dialog>

  </div>

</template>
<script>

import FormBox from '@/components/FormBox'
import WqSelect from '@/components/FormBox/WqSelect'
import WqTable from '@/components/WqTable'

const defaultChangeGoodsPostForm = {
  id: '',
  change_num: '',
  total_price: '',
  comment: ''
}

const defaultConsumeGoodsPostForm = {
  id: '',
  change_num: '',
  comment: ''
}

const defaultGoodsPostForm = {
  id: '',
  type: '',
  name: '',
  integral: '', // 兑换积分
  shipments_type: '',
  purchase_type: '',
  photo: '',
  stock_alert: '',
  warehouse_id: '',
  month_max_num: 0,
  single_purchase_quantity: ''
}

export default {
  name: 'TurnStudentList',
  components: {
    // Select
    WqTable,
    FormBox,
    WqSelect
  },

  data() {
    return {
      lists: [],
      changeForms: [
        { type: 'inputnumber', bindValue: 'change_num', label: '数量调整', require: true },
        { type: 'input', bindValue: 'total_price', label: '总价(元)', require: true },
        { type: 'input', bindValue: 'comment', label: '备注', require: true }
      ],
      consumeForms: [
        { type: 'inputnumber', bindValue: 'change_num', label: '损耗数量', min: 0, require: true },
        { type: 'input', bindValue: 'comment', label: '备注', require: true }
      ],
      goodForms: [
        { type: 'input', bindValue: 'name', label: '名称', require: true },
        { type: 'custom', bindValue: 'type', label: '类型', require: true },
        { type: 'inputnumber', min: 1, bindValue: 'integral', label: '兑换积分', require: true },
        { type: 'custom', bindValue: 'shipments_type', label: '发货类型', require: true },
        { type: 'custom', bindValue: 'purchase_type', label: '合约类型', require: true },
        { type: 'uploadimage', bindValue: 'photo', label: '物品图片', require: true },
        { type: 'inputnumber', min: 1, bindValue: 'stock_alert', label: '库存预警值', require: true },
        { type: 'custom', min: 1, bindValue: 'warehouse_id', label: '仓库', require: true },
        { type: 'inputnumber', min: 0, bindValue: 'month_max_num', label: '最大申请数量' },
        { type: 'inputnumber', min: 1, bindValue: 'single_purchase_quantity', label: '数量步进值', require: true }

      ],
      getTypeListsData() {
        return this.goodsTypeLists
      },
      rules: {
        change_num: [{
          require: true,
          validator: (rule, value, callback) => {
            if (value == 0) {
              callback(new Error('请填写数量'))
            }
            callback()
          },
          trigger: ['blur', 'change']
        }],
        total_price: [{
          require: true,
          validator: (rule, value, callback) => {
            if (isNaN(value) || value < 0) {
              callback(new Error('总价必须为数字,且大于1'))
            }
            if (!value) {
              callback(new Error('请填写总价'))
            }
            callback()
          },
          trigger: ['blur', 'change']
        }]
      },
      changePostForm: Object.assign({}, defaultChangeGoodsPostForm),
      consumePostForm: Object.assign({}, defaultConsumeGoodsPostForm),
      goodPostForm: Object.assign({}, defaultGoodsPostForm),
      tableKey: 0,
      goodsFormKey: 0,
      goodsTypeLists: [],
      purchaseTypeLists: [],
      shipmentsTypeLists: [],
      warehouseList: [],
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      historytablekey: 0,
      total: 0,
      listQuery: {
        type: '', // 物品类型
        name: '',
        in_sale: '',
        shipments_type: '',
        purchase_type: '',
        stock_alert: '',
        id: ''
      }

    }
  },
  created() {
  },
  methods: {
    fnGetGoodsList(res) {
      this.goodsTypeLists = this.fnConvertObjectToArray(res.goods_type)
      this.purchaseTypeLists = this.fnConvertObjectToArray(res.purchase_type)
      this.shipmentsTypeLists = this.fnConvertObjectToArray(res.shipments_type)
      this.warehouseList = res.warehouseList
    },
    fnConvertObjectToArray(objs) {
      const ary = []
      for (const key in objs) {
        ary.push({ value: key, label: objs[key] })
      }
      return ary
    },
    fnFollow(row) {
      this.$router.push({ path: '/admin/points/scoreLists', query: { sub_id: row.sub_id, sub_name: row.sub_name }})
    },
    fnUpdate(row) {

    },
    fnConsume(row) {
      this.consumePostForm = Object.assign({}, defaultConsumeGoodsPostForm, { id: row.id })
      this.dialogVisible3 = true
    },
    fnUpdateTable() {
      this.$refs['puchselisttable'].fetchTableData()
    },
    fnDownOrUp(row, type) {
      const typeMap = {
        on: '上架',
        off: '下架',
        delete: '删除'
      }
      this.$confirm(`确认${typeMap[type]}《${row.name}》物品么？`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', showClose: false }).then(() => {
        this.$http.launchAndRetireAndDeleteGoods({ type, id: row.id }).then(res => {
          if (res.code == 200) {
            this.$message({ type: 'success', message: '操作成功!' })
            this.fnUpdateTable()
          }
        })
      })
    },
    fnUpdateStock(row) {
      this.changePostForm = Object.assign({}, defaultChangeGoodsPostForm, { id: row.id })
      this.dialogVisible2 = true
    },
    fnSubmitStockChange(postFrom) {
      this.$http.changeGoodsStock(postFrom).then((res) => {
        if (res.code == 200) {
          this.$message({ type: 'success', message: '库存操作成功!' })
          this.dialogVisible2 = false
          this.fnUpdateTable()
        }
      })
    },
    fnSubmitConsume(postForm) {
      this.$http.changeGoodsLoss(postForm).then((res) => {
        if (res.code == 200) {
          this.$message({ type: 'success', message: '损耗操作成功!' })
          this.dialogVisible3 = false
          this.fnUpdateTable()
        }
      })
    },
    fnStockLists(row) {
      this.listQuery.id = row.id
      this.historytablekey++
      this.$nextTick(() => {
        this.dialogVisible1 = true
      })
    },
    fnCreateSumbit(postFrom) {
      this.$http.setGoods(postFrom).then((res) => {
        if (res.code == 200) {
          this.$message({ type: 'success', message: `物品${postFrom.id ? '修改' : '创建'}成功!` })
          this.dialogVisible4 = false
          this.fnUpdateTable()
        }
      })
    },
    fnCreate(row) {
      this.goodPostForm = Object.assign({}, defaultGoodsPostForm, row)
      this.goodsFormKey++
      this.dialogVisible4 = true
    }

  }
}
</script>
<style lang="scss">
.el-image-viewer__wrapper .el-icon-circle-close {
  color:white
}
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
